import styled from 'styled-components'

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 1rem;
    padding: 1rem 0.4rem 0 0.4rem;
    width: 100%;
    gap: 1rem;
`
